import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';

$.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null) {
     return null;
  }
  return decodeURI(results[1]) || 0;
}

document.addEventListener('DOMContentLoaded', function() {
  var calendarEl = document.getElementById('calendar1');
  if (typeof(calendarEl) != 'undefined' && calendarEl != null)
  {
    var url = location.protocol + '//' + location.host + location.pathname + '/schedule';
    var calendar = new Calendar(calendarEl, {
    	header: {
          left: 'prev',
          center: 'title',
          right : 'next'
      },
      plugins: [ dayGridPlugin ],
      contentHeight: 'auto',
      showNonCurrentDates: false,
      fixedWeekCount: false,
      datesRender: function(info){
        if (moment(info.view.activeStart).isBefore(moment(),'day')) $(".fc-prev-button").hide();
        else $(".fc-prev-button").show();
        if (moment(info.view.activeEnd).isAfter(moment().add(1, 'year'),'day')) $(".fc-next-button").hide();
        else $(".fc-next-button").show();      
        $('.fc-day-top').addClass('fc-disabled');
      },
      eventSources: [{
        url: url
      }],
      eventRender: function (info) {
        $('#calendar1').find('.fc-day-top[data-date="' + moment(info.event.start).format("YYYY-MM-DD") + '"]').removeClass('fc-disabled').addClass('fc-has-events');
      },
      navLinks: true,
      navLinkDayClick: function(date, jsEvent) {
        jsEvent.preventDefault();
        if($('#calendar1').find('.fc-day-top[data-date="' + moment(date).format("YYYY-MM-DD") + '"]').hasClass('fc-has-events')) {
          $.ajax({
              type: 'GET',
              async: false,
              url: location.protocol + '//' + location.host + location.pathname + '/variants?date=' + moment(date).format("YYYY-MM-DD"),
              dataType: "script"
          });
        }
      }
    });
    calendar.render();
    var start_date = $.urlParam('start_date');
    if (start_date != null) calendar.gotoDate(start_date);
    else {
      start_date = $("#min_product_date").val();
      if (start_date != null) calendar.gotoDate(start_date);
    }
  }
});